/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Municipality } from '../../models/municipality';

export interface UpdateMunicipality$Params {
  id: string;
      body?: Municipality
}

export function updateMunicipality(http: HttpClient, rootUrl: string, params: UpdateMunicipality$Params, context?: HttpContext): Observable<StrictHttpResponse<Municipality>> {
  const rb = new RequestBuilder(rootUrl, updateMunicipality.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Municipality>;
    })
  );
}

updateMunicipality.PATH = '/municipality/{id}';
